export const UPDATE_APILOGS_STATE = 'UPDATE_APILOGS_STATE'
export const UPDATE_APILOGS_SELECTED_FILTERS = 'UPDATE_APILOGS_SELECTED_FILTERS'
export const APILOGS_LOADED = 'APILOGS_LOADED'
export const MORE_APILOGS_RECEIVED = 'MORE_APILOGS_RECEIVED'




// WEBPACK FOOTER //
// ./src/data/redux/apilogs_details/actiontypes.js